interface IEnvCfg {
  version: string;
  auth_host: string;
  api_host: string;
  loginUrl: string;
  registerUrl: string;
  noPermissionsUrl: string;
}
export const server = import.meta.env.SERVER;
export const host = import.meta.env.HOST;
export const fcHost = import.meta.env.FC_HOSTNAME;
export const debugMode = new URL(host)?.hostname === 'localhost';
export const EnvConst: IEnvCfg = {
  version: `${import.meta.env.VERSION}`,
  auth_host: `${server}/auth`,
  api_host: `${server}/api/v1`,
  loginUrl: `${server}/auth/login`,
  registerUrl: `${fcHost}/cred/#/sign-up`,
  noPermissionsUrl: `${fcHost}/asset`
};
/**
 * @description Need modification to adapt sandbox?
 */
export const HomeElms = {
  name: 'FortiSOAR',
  fcName: 'FortiSOAR'
};

export const InstanceAction = {
  resize: 'resize',
  upgrade: 'upgrade',
  reboot: 3,
  createSnapshot: 4,
  revertSnapshot: 5
};

export const ProvisionStage = {
  REDO: {
    minute: 4,
    second: 0
  },
  LICENSE_CHECK: {
    minute: 9,
    second: 0
  },
  ASSIGNING: {
    minute: 8,
    second: 0
  },
  NETWORK_SETUP: {
    minute: 6,
    second: 0
  },
  LICENSE_INSTALLING: {
    minute: 4,
    second: 0
  },
  DONE: {
    minute: 0,
    second: 0
  }
};

export const ProvisionCols = [
  'sn',
  'region',
  'image-version'
  // 'timezone',
  // 'adom-version'
];

export const ClusterHelper: Record<string, string> = {
  INIT: 'Cluster creation request sent successfully. Please wait for administrator to setup the cluster',
  IDLE: 'Cluster Configured successfully'
};
